import React from "react";
import './index.css';

const Article = (props) => {
  return (
    <div className={`quarterArticle article${props.num}`}>
        <h2 onClick={(e) => {e.preventDefault(); window.location.href=props.link;}}>{props.title}</h2>
        <h3>{props.author}</h3>
        <div className="bottomArticleText">
            <p>{props.desc}</p>
            <button className="readButton" onClick={(e) => {e.preventDefault(); window.location.href=props.link;}}>Read more</button>
        </div>
    </div>
  );
};

export default Article;
